import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";
import { useMarketLocalizations } from "../../hooks/useMarketLocalizations";

import { Heading5, Modal } from "../../../../../components";
import { LocalizationsModalControlButtons } from "./LocalizationsModalControlButtons";
import { LocalizationsTable } from "./LocalizationsTable";

export const LocalizationsModal = ({ market, isActive, setActive, onSaveLocalizations }) => {
  const marketLocalizations = useMarketLocalizations(market);

  const [newMarketLocalizations, setNewMarketLocalization] = useState([]);

  useEffect(() => {
    if (isActive) {
      setNewMarketLocalization(marketLocalizations);
    }
  }, [JSON.stringify(marketLocalizations), isActive]);

  const onSave = () => {
    onSaveLocalizations(newMarketLocalizations);
    onModalClose();
  };

  const onModalClose = () => {
    setActive(false);
    setNewMarketLocalization([]);
  };

  const onToggleValue = (language) => {
    const localizationIdx = newMarketLocalizations?.findIndex((l) => l.name === language);

    if (localizationIdx === -1) {
      setNewMarketLocalization((prev) => [...prev, { name: language, isDefault: false }]);
    } else {
      setNewMarketLocalization((prev) => [
        ...prev.slice(0, localizationIdx),
        ...prev.slice(localizationIdx + 1)
      ]);
    }
  };

  const onSelectDefault = (language) => {
    const updatedLocalizations = newMarketLocalizations.map((l) => {
      return { ...l, isDefault: l.name === language };
    });

    setNewMarketLocalization(updatedLocalizations);
  };

  return (
    <Modal
      id="localizations-modal"
      active={isActive}
      setActive={onModalClose}
      modalHeader={<Heading5>{t(strCode.LOCALIZATION_TITLE)}</Heading5>}
      modalFooter={
        <LocalizationsModalControlButtons onSave={onSave} onCancel={onModalClose} loading={false} />
      }>
      <LocalizationsTable
        marketLocalizations={newMarketLocalizations}
        active={isActive}
        onToggleValue={onToggleValue}
        onSelectDefault={onSelectDefault}
      />
    </Modal>
  );
};

LocalizationsModal.propTypes = {
  market: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onSaveLocalizations: PropTypes.func.isRequired
};
